import { render } from "./TabBodyEmission.vue?vue&type=template&id=77e7ef3d&scoped=true"
import script from "./TabBodyEmission.vue?vue&type=script&lang=js"
export * from "./TabBodyEmission.vue?vue&type=script&lang=js"

import "./TabBodyEmission.vue?vue&type=style&index=0&id=77e7ef3d&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e7ef3d"]])

export default __exports__